'use strict';function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++)arr2[i]=arr[i];return arr2}else{return Array.from(arr)}}

const _=require('pulsar-utils/dist-es6/_');
const Entity=require('pulsar-utils/dist-es6/domain/entity');
const Guid=require('pulsar-utils/dist-es6/domain/guid');
const NotificationType=require('pulsar-dashboard-core/dist-es6/domain/notificationType');

const _setSerializer={
serialize:function(value){return _coerceNullable(value,_.toArray)},
deserialize:function(value){return _coerceNullable(value,function(v){return new Set(v)})}};


const SETTING_TYPES_BY_ID={
groupsSidebarVisible:{
type:'boolean',
ensureExists:!0,
defaultValue:!0},

showAlertingOnly:{
type:'boolean',
defaultValue:!0},

showActiveOnly:{
type:'boolean',
defaultValue:!0},

selectedGroupId:{
type:'string',
validators:[_ensureGuidString]},

selectedIncidentTypeCode:{
type:'string'},

selectedIncidentBucketTypeLabel:{
type:'string'},

expandedSidebarGroups:{
type:Set,
validators:[_ensureAllValuesAreGuidStrings],
serializer:_setSerializer},

selectedNotificationType:{
type:NotificationType,
serializer:{
serialize:function(value){return _coerceNullable(value,function(v){return v.toMongo()})},
deserialize:function(value){return _coerceNullable(value,NotificationType.fromMongo)}}}};





{
const{DefaultAvailableDutyStatuses:DefaultAvailableDutyStatuses}=require('../../../dist-es6/client/features/emirates/emiratesDashboard/components/dutyStatusSelectorDirective/dutyStatusSelectorDirective');

_.assign(SETTING_TYPES_BY_ID,{
availableDutyStatuses:{
type:Set,
defaultValue:new Set(DefaultAvailableDutyStatuses),
validators:[_ensureNonZeroLengthArray],
serializer:_setSerializer},

selectedDutyStatuses:{
type:Set,
defaultValue:new Set,
serializer:_setSerializer},

staffSearchAutoRefreshOn:{
type:'boolean',
defaultValue:!1}});


};

const DEFAULT_STICKY_SETTINGS=_getDefaultStickySettings();

const TAB_SELECTION_TYPES=new Set([
'dashboardMain',
'notificationSettings',
'fleetInsightMain',
'fatigueTrends',
'personalSchedule']);


const PASSTHROUGH_SETTINGS=new Set([].concat(_toConsumableArray(
_.keys(SETTING_TYPES_BY_ID).filter(function(propertyId){return!_.exists(SETTING_TYPES_BY_ID[propertyId].serializer)})),_toConsumableArray(
_.toArray(TAB_SELECTION_TYPES).map(_asTabSelectionProperty))));


const ALL_STICKY_SETTINGS=new Set([].concat(_toConsumableArray(
PASSTHROUGH_SETTINGS.values()),_toConsumableArray(
_.keys(SETTING_TYPES_BY_ID).filter(function(propertyId){return _.exists(SETTING_TYPES_BY_ID[propertyId].serializer)}))));let


StickySettings=function(_Entity){_inherits(StickySettings,_Entity);
function StickySettings(inputs,userId){_classCallCheck(this,StickySettings);var _this=_possibleConstructorReturn(this,
_Entity.call(this,userId));

_assignGettersAndSettersForTabSelectionTypes(_this);
_assignGettersAndSettersForTypeValidatedSettings(_this);
_mapSettingsToObject(function(s){return inputs[s]},_this);return _this;
}StickySettings.prototype.

toJSON=function toJSON(){var _this2=this;
return _mapSettingsToObject(function(setting){return StickySettings.serialize(setting,_this2[setting])});
};StickySettings.

fromMongo=function fromMongo(obj){
return new StickySettings(_mapSettingsToObject(function(setting){return StickySettings.deserialize(setting,obj[setting])}),obj._id);
};StickySettings.

isValidSetting=function isValidSetting(setting){
return ALL_STICKY_SETTINGS.has(setting);
};StickySettings.

serialize=function serialize(setting,value){
if(PASSTHROUGH_SETTINGS.has(setting)){
return value;
}

const serializer=_.get(SETTING_TYPES_BY_ID[setting],'serializer');
if(!_.exists(serializer)){
throw new Error(`Tried to serialize unknown setting '${setting}'`);
}

return serializer.serialize(value);
};StickySettings.

deserialize=function deserialize(setting,value){
if(PASSTHROUGH_SETTINGS.has(setting)){
return value;
}

const serializer=_.get(SETTING_TYPES_BY_ID[setting],'serializer');
if(!_.exists(serializer.deserialize)){
throw new Error(`Tried to deserialize unknown setting '${setting}'`);
}

return serializer.deserialize(value);
};StickySettings.

makeWithDefaultSettings=function makeWithDefaultSettings(userId){
return new StickySettings(_.cloneDeep(DEFAULT_STICKY_SETTINGS),userId);
};return StickySettings}(Entity);


function _asTabSelectionProperty(tabSelectionType){
return`${tabSelectionType}TabSelection`;
}

function _mapSettingsToObject(func){let obj=arguments.length>1&&arguments[1]!==void 0?arguments[1]:{};
for(const setting of ALL_STICKY_SETTINGS){
obj[setting]=func(setting);
}
return obj;
}

function _getValidateNullableType(value,type){
if(!_.exists(value)){
return null;
}

_.ensureInstanceOf(type,value);for(var _len=arguments.length,additionalValidators=Array(_len>2?_len-2:0),_key=2;_key<_len;_key++){additionalValidators[_key-2]=arguments[_key]}
additionalValidators.forEach(function(validator){return validator(value)});
return value;
}

function _coerceNullable(value){let func=arguments.length>1&&arguments[1]!==void 0?arguments[1]:_.identity;
return _.exists(value)?func(value):null;
}

function _ensureGuidString(s){
_.ensureInstanceOf('string',s);
if(!Guid.isValid(s)){
throw new TypeError('expected Guid string');
}
}

function _ensureAllValuesAreGuidStrings(values){
return _.toArray(values).forEach(_ensureGuidString);
}

function _ensureNonZeroLengthArray(arr){
if(_.toArray(arr).length===0){
throw new Error(`Expected array to have at least 1 value: ${arr}`);
}
}

const _ignoredStickyTabSelectionIndexes={
personalSchedule:[2]};


function _isStickyTabSelectionIndex(tabSelectionType,index){
if(!_ignoredStickyTabSelectionIndexes[tabSelectionType]){
return!0;
}

return _ignoredStickyTabSelectionIndexes[tabSelectionType].indexOf(index)===-1;
}

function _assignGettersAndSettersForTabSelectionTypes(instance){
for(const tabSelectionType of TAB_SELECTION_TYPES.values()){
Object.defineProperty(instance,`${_asTabSelectionProperty(tabSelectionType)}`,{
get:function(){return instance[`_${_asTabSelectionProperty(tabSelectionType)}`]},
set:function(value){
if(!_isStickyTabSelectionIndex(tabSelectionType,value)){
return instance[`_${_asTabSelectionProperty(tabSelectionType)}`];
}

return instance[`_${_asTabSelectionProperty(tabSelectionType)}`]=_getValidateNullableType(value,'number');
}});

}
}

function _assignGettersAndSettersForTypeValidatedSettings(instance){
for(const propertyId in SETTING_TYPES_BY_ID){
const{
type:type,
validators=[],
ensureExists=!1}=
SETTING_TYPES_BY_ID[propertyId];

if(!_.exists(type)){
throw new Error(`StickySetting property definition for "${propertyId}" does not have a defined 'type' which is required for validation. Refusing to initialize StickySettings.`);
}

const _privatePropertyName=`_${propertyId}`;

Object.defineProperty(instance,propertyId,{
get:function(){return instance[_privatePropertyName]},
set:ensureExists?
function(value){
_.ensureInstanceOf(type,value);
validators.forEach(function(validator){return validator(value)});
return instance[_privatePropertyName]=value;
}:
function(value){return instance[_privatePropertyName]=_getValidateNullableType.apply(void 0,[value,type].concat(_toConsumableArray(validators)))}});

}
}

function _getDefaultStickySettings(){
const defaultSettings={};

for(const propertyId in SETTING_TYPES_BY_ID){
if(!_.has(SETTING_TYPES_BY_ID[propertyId],'defaultValue')){
continue;
}
defaultSettings[propertyId]=SETTING_TYPES_BY_ID[propertyId].defaultValue;
}

return defaultSettings;
}

module.exports=StickySettings;
//# sourceMappingURL=stickySettings.js.map
